import { FirebaseError } from '@angular/fire/app';

export const errorHandler = (error: FirebaseError): string => {
  let errorMessage = 'An unknown error occurred';
  switch (error.code) {
    case 'auth/claims-too-large':
      errorMessage = 'The custom claims payload exceeds the maximum allowed size.';
      break;
    case 'auth/email-already-exists':
      errorMessage = 'The provided email is already in use.';
      break;
    case 'auth/id-token-expired':
      errorMessage = 'The provided ID token has expired.';
      break;
    case 'auth/id-token-revoked':
      errorMessage = 'The provided ID token has been revoked.';
      break;
    case 'auth/insufficient-permission':
      errorMessage = 'Insufficient permissions to access the requested resource.';
      break;
    case 'auth/internal-error':
      errorMessage = 'An unexpected internal error occurred.';
      break;
    case 'auth/invalid-argument':
      errorMessage = 'An invalid argument was provided.';
      break;
    case 'auth/invalid-claims':
      errorMessage = 'The provided custom claims are invalid.';
      break;
    case 'auth/invalid-continue-uri':
      errorMessage = 'The continue URL is invalid.';
      break;
    case 'auth/invalid-creation-time':
      errorMessage = 'The creation time provided is invalid.';
      break;
    case 'auth/invalid-credential':
      errorMessage = 'The provided credential is invalid.';
      break;
    case 'auth/invalid-disabled-field':
      errorMessage = 'The disabled field is invalid.';
      break;
    case 'auth/invalid-display-name':
      errorMessage = 'The display name is invalid.';
      break;
    case 'auth/invalid-dynamic-link-domain':
      errorMessage = 'The dynamic link domain is invalid.';
      break;
    case 'auth/invalid-email':
      errorMessage = 'The email is invalid.';
      break;
    case 'auth/invalid-email-verified':
      errorMessage = 'The email verification status is invalid.';
      break;
    case 'auth/invalid-hash-algorithm':
      errorMessage = 'The hash algorithm is invalid.';
      break;
    case 'auth/invalid-hash-block-size':
      errorMessage = 'The hash block size is invalid.';
      break;
    case 'auth/invalid-hash-derived-key-length':
      errorMessage = 'The hash derived key length is invalid.';
      break;
    case 'auth/invalid-hash-key':
      errorMessage = 'The hash key is invalid.';
      break;
    case 'auth/invalid-hash-memory-cost':
      errorMessage = 'The hash memory cost is invalid.';
      break;
    case 'auth/invalid-hash-parallelization':
      errorMessage = 'The hash parallelization is invalid.';
      break;
    case 'auth/invalid-hash-rounds':
      errorMessage = 'The hash rounds are invalid.';
      break;
    case 'auth/invalid-hash-salt-separator':
      errorMessage = 'The hash salt separator is invalid.';
      break;
    case 'auth/invalid-id-token':
      errorMessage = 'The ID token is invalid.';
      break;
    case 'auth/invalid-last-sign-in-time':
      errorMessage = 'The last sign-in time is invalid.';
      break;
    case 'auth/invalid-page-token':
      errorMessage = 'The page token is invalid.';
      break;
    case 'auth/invalid-password':
      errorMessage = 'The password is invalid.';
      break;
    case 'auth/invalid-password-hash':
      errorMessage = 'The password hash is invalid.';
      break;
    case 'auth/invalid-password-salt':
      errorMessage = 'The password salt is invalid.';
      break;
    case 'auth/invalid-phone-number':
      errorMessage = 'The phone number is invalid.';
      break;
    case 'auth/invalid-photo-url':
      errorMessage = 'The photo URL is invalid.';
      break;
    case 'auth/invalid-provider-data':
      errorMessage = 'The provider data is invalid.';
      break;
    case 'auth/wrong-password':
      errorMessage = 'The password or email is invalid.';
      break;
    case 'auth/invalid-provider-id':
      errorMessage = 'The provider ID is invalid.';
      break;
    case 'auth/invalid-session-cookie-duration':
      errorMessage = 'The session cookie duration is invalid.';
      break;
    case 'auth/invalid-uid':
      errorMessage = 'The user ID is invalid.';
      break;
    case 'auth/invalid-user-import':
      errorMessage = 'The user record to import is invalid.';
      break;
    case 'auth/maximum-user-count-exceeded':
      errorMessage = 'The maximum allowed number of users to import has been exceeded.';
      break;
    case 'auth/missing-android-pkg-name':
      errorMessage = 'The Android package name is missing.';
      break;
    case 'auth/missing-continue-uri':
      errorMessage = 'The continue URL is missing.';
      break;
    case 'auth/missing-hash-algorithm':
      errorMessage = 'The hashing algorithm is missing.';
      break;
    case 'auth/missing-ios-bundle-id':
      errorMessage = 'The iOS bundle ID is missing.';
      break;
    case 'auth/missing-uid':
      errorMessage = 'The user ID is missing.';
      break;
    case 'auth/missing-oauth-client-secret':
      errorMessage = 'The OAuth client secret is missing.';
      break;
    case 'auth/operation-not-allowed':
      errorMessage = 'The operation is not allowed.';
      break;
    case 'auth/phone-number-already-exists':
      errorMessage = 'The phone number is already in use.';
      break;
    case 'auth/project-not-found':
      errorMessage = 'The Firebase project could not be found.';
      break;
    case 'auth/reserved-claims':
      errorMessage = 'One or more custom user claims are reserved.';
      break;
    case 'auth/session-cookie-expired':
      errorMessage = 'The session cookie has expired.';
      break;
    case 'auth/session-cookie-revoked':
      errorMessage = 'The session cookie has been revoked.';
      break;
    case 'auth/too-many-requests':
      errorMessage = 'The number of requests exceeds the maximum allowed.';
      break;
    case 'auth/uid-already-exists':
      errorMessage = 'The user ID is already in use.';
      break;
    case 'auth/unauthorized-continue-uri':
      errorMessage = 'The continue URL is not whitelisted.';
      break;
    case 'auth/user-not-found':
      errorMessage = 'The password or email is invalid.';
      break;
  }
  return errorMessage;
};
